import i18n from '../../../i18n';

const p = (key, opts) => i18n.t(`modules.shared.aiAgent.generalModule.${key}`, opts);

/** Default agent mode — cross-module ERP help */
const general = {
  id: 'general',
  moduleKey: null,
  label: p('label'),
  shortLabel: p('shortLabel'),
  routePrefixes: [],
  placeholder: p('placeholder'),
  promptAddon: p('promptAddon'),
  quickChips: [
    {
      label: p('quickChips.navigation_help.label'),
      prompt: p('quickChips.navigation_help.prompt'),
    },
    {
      label: p('quickChips.active_modules.label'),
      prompt: p('quickChips.active_modules.prompt'),
    },
  ],
  vectorizeTypes: ['client', 'product', 'supplier', 'service', 'category'],
};

export default general;
